export class FreeTextFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "contains",
            "baseName": "contains",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FreeTextFilters.attributeTypeMap;
    }
    constructor() {
    }
}
